import { authApi } from "../../store/services/AuthService";

const useLogout = () => {
  const [logout, { isLoading }] = authApi.useLogoutMutation();

  return { logout, isLoggingOut: isLoading };
};

export default useLogout;